import _ from 'lodash/fp'
import {willUseSharedCallback} from '@startlibs/core'
import {createSelfStatefulContext, createStatefulContext} from "../../hooks/useSignalUpdate";

// export const [useActivityLog,useActivityLogRef,setActivityLog,getActivityLog] = willUseSharedState([])
export const [ActivityLogProvider,[useSelectActivityLog,useSetActivityLog]] = createStatefulContext([])

let i = 1;
const getNextKey = () => i++


export const updateActivityLogFile = (file,state,{
  /* remove uploaded and files to improve memory collection */uploaded,files,
  ...recordInfo
}) => logList => {
  if (file) {
    const index = _.findIndex(['file',file],logList)
    if (index>=0) {
      return _.update(index,(item)=> ({...item,...recordInfo,state,updateDate:new Date()}),logList)
    } else {
      return logList.concat({...recordInfo,file,state,updateDate:new Date(),key:getNextKey()})
    }
  } else {
    return logList
  }
}
export const useUpdateActivityLogFile = () => {
  const setActivityLog = useSetActivityLog()
  return (file,state,recordInfo) => setActivityLog(updateActivityLogFile(file,state,recordInfo))
}

export const updateActivityLogBy = (key,value,state) => _.map((item => item[key] === value ? _.set('state',state,item) : item))

export const useUpdateActivityLogBy = () => {
  const setActivityLog = useSetActivityLog()
  return (key,value,state) => setActivityLog(updateActivityLogBy(key,value,state))
}
export const [useRegisterOpenDetails,openDetails] = willUseSharedCallback()